import {useState, type FC, useEffect} from 'react';
import {Box, Divider, IconButton, Typography} from '@mui/material';
import {FilterDatePicker} from 'components/Generic/DatePickersV2/FilterDatePicker';
import CloseIcon from '@mui/icons-material/Close';

import {TransferTable, type TransferTableProps} from './Transfer';
import {type ModalDialogProps} from 'interfaces';
import GenericDialog from 'components/Generic/GenericDialog';
import {useTranslation} from 'react-i18next';
import {useGetTransfer} from 'hooks/swr';
import {dateReader} from 'helpers/UnitsFormatHandler';

const TransferModal: FC<ModalDialogProps<any, TransferTableProps>> = ({
  dialogProps,
  dialogTitleProps,
  modalComponentProps: {formDataPayload},
}) => {
  const {t} = useTranslation('common');

  const [date, setDate] = useState<Date | null>(formDataPayload.date);

  const {data: transfer} = useGetTransfer({resourceId: formDataPayload.id});
  useEffect(() => {
    if (transfer) {
      const {date} = transfer;
      setDate(dateReader(date));
    }
  }, [transfer]);

  const transferTableProps = {...formDataPayload, date};
  return (
    <GenericDialog {...dialogProps}>
      <Box>
        <Box display="flex" alignItems="center" {...dialogTitleProps}>
          <Box display="flex" m={1} p={1} flexGrow={1} alignItems="center">
            <Typography variant="h6" pl={1} pr={3}>
              {' '}
              {t('transfer')}
            </Typography>
            <FilterDatePicker
              value={date ?? new Date()}
              onDateChange={(value) => {
                value && setDate(value);
              }}
            />
          </Box>
          <Divider orientation="vertical" flexItem />
          <Box m={1} mx={1.5}>
            <IconButton
              aria-label="close"
              onClick={(event) => {
                dialogProps.onClose && dialogProps.onClose(event, 'escapeKeyDown');
              }}
              size="medium"
            >
              <CloseIcon color="secondary" />
            </IconButton>
          </Box>
        </Box>
        <Divider />
        <TransferTable {...transferTableProps} />
      </Box>
    </GenericDialog>
  );
};

export default TransferModal;
